import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { EventListingResponse } from './EventListingResponse.Type';
import type { ResponsiveImageFields } from 'models/responsive-image';

export type Audience = {
  id: string;
  name: string;
};

export type LocationType = {
  id: string;
  key: string;
  phrase: string;
};

export type OccurrenceDateTime = {
  id: string;
  time: string;
  date: Date;
  endDate: Date;
  isCanceled: boolean;
};

export type EventCard = {
  id: string;
  event: EventListingResponse;
  date: Date;
  endDate: Date;
  formattedDate: string;
  times: OccurrenceDateTime[];
  isFeatured: boolean;
};

export type EventListingFields = ResponsiveImageFields & {
  title: string;
  eventFallbackImage: ImageField;
  sortDescending: boolean;
  numberOfResultsToDisplay: number;
  featuredEventIds: string[];
  eventDetailPageUrl: string;
  audienceFilters: Audience[];
  locationTypeFilters: LocationType[];
  eventsToShow: string;
};

export type EventTypeData = {
  id: string;
  name: string;
};

export type Filter =
  | {
      name: string;
      value: string;
      operator: string;
    }
  | {
      AND?: Filter[];
      OR?: Filter[];
    };
